import { Task, Timestamp, WeekDays } from '@griply/types';
import { endOfDay, isAfter, isBefore, isSameDay, startOfDay } from 'date-fns';

import { getDueTaskPlanning, getTaskPlanning } from './get-task-planning';

export type GetTaskPlannedOccurrenceForDateOptions = {
  weekStartsOn: WeekDays;
  today: Timestamp;
  uncompletedOnly?: boolean;
};

export const getTaskPlannedOccurrenceForDate = (
  task: Task,
  date: Timestamp,
  {
    weekStartsOn,
    today,
    uncompletedOnly = true,
  }: GetTaskPlannedOccurrenceForDateOptions,
) => {
  // an outstanding occurrence outranks a slot generated for the day
  if (uncompletedOnly && (isSameDay(date, today) || isBefore(date, today))) {
    const duePlanning = getDueTaskPlanning(task, {
      date,
      today,
      weekStartsOn,
      uncompletedOnly,
    });

    if (duePlanning[0]) {
      return duePlanning[0];
    }
  }

  const planning = getTaskPlanning(task, {
    startDate: startOfDay(date),
    endDate: endOfDay(date),
    today,
    weekStartsOn,
    uncompletedOnly,
  });
  const plannedOnDate = planning.find(({ date: _date }) =>
    isSameDay(_date, date),
  );

  if (plannedOnDate) {
    return plannedOnDate;
  }

  return planning.find(({ date: _date }) => isAfter(_date, date));
};
